<template>
  <div>
    <van-pull-refresh
      v-model="refreshing"
      @refresh="onRefresh"
    >
      <van-empty v-if="recommendList.length == 0" description="暂无内容" />
      <van-list>
        <div class="recommend-box">
          <div
            class="recommend-item"
            v-for="(item,index) in recommendList"
            @click="openTextUrl(item)"
            :key="index"
          >
            <!-- <div class="recommend-title">{{item.activityRecommendTitle}}</div>
            <div class="recommend-time">{{getTime(item.activityRecommendPublishTime)}}</div>
            <div class="recommend-img">
              <img
                :src="item.activityRecommendImg"
                alt=""
              >
            </div> -->
            <div class="img-box">
            <img
              :src="item.activityRecommendImg"
              alt=""
            >
          </div>
          <div class="store-text">
            <div class="store-title">
              {{item.activityRecommendTitle}}
            </div>
            <div class="btn-box">
              <div><div class="origin"></div>
              <div class="recommend-time">{{getTime(item.activityRecommendPublishTime)}}</div></div>
              <div class="my-btn">
                阅读
              </div>
            </div>
          </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import axios from "@/utils/NewLive";
import{getQRcode} from '@/api/tvlive'
import { Toast } from 'vant';
export default {
  data () {
    return {
      recommendList:[], // 推荐列表
      loading: false,
      finished: false,
      refreshing: false,
      config:{},
    };
  },
  props: {
    userinfo: {
      default: () => {
        return {};
      },
      required: true,
    }
  },
  mounted () {
    getQRcode().then((res) => {
      this.config=res.data.data
    });
    this.activityId=this.$route.query.id
    this.getRecommend(this.activityId)
  },
  methods: {
    // 时间格式转换
    getTime (timestamp) {
        let time = new Date(timestamp)
        let year = time.getFullYear()
        const month = (time.getMonth() + 1).toString().padStart(2, '0')
        const date = (time.getDate()).toString().padStart(2, '0')
        const hours = (time.getHours()).toString().padStart(2, '0')
        const minute = (time.getMinutes()).toString().padStart(2, '0')
        const second = (time.getSeconds()).toString().padStart(2, '0')
        return year + '-' + month + '-' + date + ' ' + hours + ':' + minute + ':' + second

    },
    // 查询已推荐列表
    getRecommend (activityId) {
      axios.get(this.$api.activityrecommend+'?activityId='+activityId).then(res=>{
              if(res.status===200){
                this.recommendList = res.data.data
              }
        }).catch(() => {});
    },
    // 打开推荐链接
    openTextUrl (item) {
      let url=''
      if (item.activityRecommendReleaseType=='1') {//文稿
        url=`${this.config.domainPath}/newsShare?id=${item.activityRecommendReleaseid}&type=${item.activityRecommendReleaseType}`
      } else if (item.activityRecommendReleaseType=='2') { // 视频
        url=`${this.config.domainPath}/videoShare?id=${item.activityRecommendReleaseid}&type=${item.activityRecommendReleaseType}`
      } else if (item.activityRecommendReleaseType=='3') { // 图集
        url=`${this.config.domainPath}/picShare?id=${item.activityRecommendReleaseid}&type=${item.activityRecommendReleaseType}`
      }else if (item.activityRecommendReleaseType=='4') { // 外链 
        url=item.path
      }else if (item.activityRecommendReleaseType == '6' || item.activityRecommendReleaseType == '10' || item.activityRecommendReleaseType == '7'|| item.activityRecommendReleaseType == '16') {
        let type=''
        switch (item.activityRecommendReleaseType) {
          case '6': type=1; break;
          case '7': type=2; break;
          case '10':type=3; break;
          case '16':type=4; break;
        }
        url=`${this.config.domainPath}/tv?id=${item.activityRecommendReleaseid}&tvType=${type}`
      }else if (item.activityRecommendReleaseType == '8') {
        url=`${this.config.domainPath}?id=${item.activityRecommendReleaseid}&tvType=${5}`
      }else if (item.activityRecommendReleaseType=='9') { // 音频
        url=`${this.config.domainPath}/audioShare?id=${item.activityRecommendReleaseid}&type=${item.activityRecommendReleaseType}`
      }
      window.open(url,'_balck')
    },
    handleClickRecommendItem (item) {
      this.$emit('handleClickItem', item)
    },
    onLoad () {
      // setTimeout(() => {
      //   if (this.refreshing) {
      //     this.recommendList = [];
      //     this.refreshing = false;
      //   }
      //   for (let i = 0; i < 10; i++) {
      //     let item = {
      //       title: '关于元旦活动问题关于元旦活动问题',
      //       time: '2021-10-15 12:00:00',
      //       img: 'https://t7.baidu.com/it/u=852388090,130270862&fm=193&f=GIF'
      //     }
      //     this.recommendList.push(item);
      //   }
      //   this.loading = false;

      //   if (this.recommendList.length >= 40) {
      //     this.finished = true;
      //   }
      // }, 1000);
    },
    onRefresh () {
      this.refreshing = true
      setTimeout(() => {
        Toast('刷新成功');
        this.refreshing = false;
      }, 1000);
    }
  },
}
</script>

<style scoped>

.recommend-box {
  width: 100%;
  background: #fff;
  box-sizing: border-box;
  margin-top: 10px;
}

.recommend-box .recommend-item {
  width: 100%;
  height: 100px;
  display: flex;
}
.img-box {
  width: 100px;
  height: 100px;
  line-height: 100px;
  background: #f7f7f7;
  text-align: center;
  margin-right: 12px;
  display: flex;
  align-items: center;
}
.recommend-box .recommend-item .img-box img {
  width: 100%;
  height: 100%;
}
.recommend-box .recommend-item .store-text {
  width: 65%;
  font-size: 14px;
}
.recommend-box .recommend-item .store-text .store-title {
  height: 45px;
  font-size: 14px;
  color: #333333;
  line-height: 22px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  margin-bottom: 12px;
}
.money {
  font-size: 14px;
  color: #be1928;
  font-weight: 700;
}
.price {
  font-size: 18px;
  font-weight: 700;
  color: #be1928;
}
.btn-box {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  font-family: SourceHan;
  font-weight: 400;
  color: #999999;
  line-height: 14px;
}
</style>